<template>
  <div class="container mb-5 mt-lg-5 d-flex flex-column gap-3 w-100">
    <!-- Contenedor de la imagen o icono -->
    <div class="d-flex justify-content-center align-items-center card-img-top rounded-4 position-relative overflow-hidden" style="height: 200px">
      <!-- Mostrar la imagen si ya está cargada -->
      <img v-if="form.PortadaUrl" :src="form.PortadaUrl" alt="Imagen seleccionada" class="rounded-4 w-100 h-100 sombra object-fit-cover">
      
      <!-- Mostrar el icono si no hay imagen -->
      <i v-else class="bi bi-image fs-1 texto-principal"></i>
      <!-- Filtro verde -->
      <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5);"></div>

      <!-- Texto encima de la imagen -->
      <div class="text-center position-absolute w-100 z-index-0">
        <p class="text-white fs-1 mb-0 fw-bold">{{ $t('misRespuestas') }}</p>
      </div>
    </div>

    <div class="d-flex flex-row align-items-start align-items-md-center justify-content-center gap-2">
      <router-link to="/formularios" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="tooltip-text">{{ $t('volver') }}</span>
      </router-link>
      <h2 class="m-0 text-wrap w-100" for="nombreFormulario">{{ form.NombreFormulario }}</h2>
    </div>
    <div>
      <div class="d-inline-flex sombra-sm align-items-center justify-content-start gap-1 bg-goethe-accent-claro-2 rounded-4 px-1" style="height: 42px;">
        <router-link :to="'/formularios/completar?idForm=' + idForm" class="btn gap-2 p-2 d-inline-flex flex-row align-items-center justify-content-center" @click="addRedirectUrl()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24"  height="24"  viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" />
            <path d="M14 2v6h6" />
            <path d="M2 15h10" style="stroke: rgb(44, 169, 188);"/>
            <path d="M9 18l3-3-3-3" style="stroke: rgb(44, 169, 188);"/>
          </svg>
          <span class="texto-principal">{{ $t('completar') }}</span>
        </router-link>
      </div>
      <div v-if="(!loading && submits.length === 0) || showBanner" class="fondo-terciario sombra-sm rounded-3 p-2 ps-3 d-flex gap-2 justify-content-between align-items-start texto-principal fade show floating-banner" role="alert" style="max-width: 300px;">
        {{ $t('clickAcaParaCompletarForm') }}
        <button type="button" class="btn p-1 d-flex align-items-center" @click="closeBanner()">
          <svg width="18" height="18" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
              <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
              <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
            </g>
          </svg>
        </button>
      </div>
    </div>

    <p class="w-100" style="white-space: pre-wrap; word-wrap: break-word;">
      <span v-html="formatDescription(form.Descripcion)"></span>
    </p>

    <!-- Respuestas -->
    <div class="d-flex flex-column gap-3">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex flex-column flex-md-row gap-2">
          <div class="d-flex flex-row gap-2 w-100">
            <div v-if="!form.ConAutorizaciones || !submits || submits.length == 0" class="position-relative">
              <!-- Ícono para abrir el menú de ordenación -->
              <i class="bi bi-filter fs-1 text-goethe-accent-claro-2 fs-4" @click="showMenuFilter = !showMenuFilter" style="cursor: pointer;"></i>
              <!-- Fondo transparente para detectar clics fuera -->
              <div v-if="showMenuFilter" class="overlay" @click="showMenuFilter = false"></div>

              <div v-if="showMenuFilter" class="dropdown-menu show position-absolute bg-goethe-accent-claro-2 border-0 user-select-none px-2" aria-labelledby="dropdownMenuButton" style="top: 100%; left: 0; z-index: 1000; min-width: 180px;">
                <p class="m-0 fs-6 texto-principal">Ordenar por:</p>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortTitulo" v-model="sortKey" value="Nombre" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                  <label class="form-check-label" for="sortTitulo">Nombre</label>
                </div>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortUltMod" v-model="sortKey" value="FechaDesc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                  <label class="form-check-label" for="sortUltMod">Fecha Desc</label>
                </div>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortCreadoPor" v-model="sortKey" value="FechaAsc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)"/>
                  <label class="form-check-label" for="sortCreadoPor">Fecha Asc</label>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center position-relative w-100">
              <!-- Ícono SVG de lupa -->
              <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2 texto-principal" style="pointer-events: none">
                <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <input type="text" class="form-control texto-principal m-0 rounded-3 border-0 fondo-terciario sombra-sm" :placeholder="$t('buscar') + '...'" v-model="search"
                style="padding-left: 35px;" @keyup.enter="getSubmits(form, currentPage)" @input="filterSubmits"/>
              <button v-if="search" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="search = ''; getSubmits(form, currentPage)">
                <i class="bi bi-x texto-principal" style="font-size: 30px;"></i> <!-- Icono de "x" -->
              </button>
            </div>
          </div>
          
          <div class="d-flex gap-2 align-items-center">
            <input type="date" class="form-control texto-principal rounded-3 border-0 fondo-terciario sombra-sm" v-model="fechaDesde" @onchange="getSubmits(form, currentPage)"/>
            <span class="texto-principal">a</span>
            <input type="date" class="form-control texto-principal rounded-3 border-0 fondo-terciario sombra-sm" v-model="fechaHasta" @onchange="getSubmits(form, currentPage)"/>
          </div>
        </div>
        <div v-if="form.ConAutorizaciones && submits && submits.length > 0" class="d-flex flex-row gap-2">
          <div class="position-relative">
            <!-- Ícono para abrir el menú de ordenación -->
            <i class="bi bi-filter fs-1 text-goethe-accent-claro-2 fs-4" @click="showMenuFilter = !showMenuFilter" style="cursor: pointer;"></i>
            <!-- Fondo transparente para detectar clics fuera -->
            <div v-if="showMenuFilter" class="overlay" @click="showMenuFilter = false"></div>

            <div v-if="showMenuFilter" class="dropdown-menu show position-absolute bg-goethe-accent-claro-2 border-0 user-select-none px-2" aria-labelledby="dropdownMenuButton" style="top: 100%; left: 0; z-index: 1000; min-width: 180px;">
              <p class="m-0 fs-6 texto-principal">Ordenar por:</p>
              <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortTitulo" v-model="sortKey" value="Nombre" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                <label class="form-check-label" for="sortTitulo">Nombre</label>
              </div>
              <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortUltMod" v-model="sortKey" value="FechaDesc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                <label class="form-check-label" for="sortUltMod">Fecha Desc</label>
              </div>
              <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortCreadoPor" v-model="sortKey" value="FechaAsc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)"/>
                <label class="form-check-label" for="sortCreadoPor">Fecha Asc</label>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap gap-2 align-items-center" v-if="form.ConAutorizaciones">
            <p class="m-0 fw-bold">{{ $t('filtros') }}:</p>
            <div v-for="estado in estados" :key="estado.IdAutorizacionEstado"
              class="form-check-pill"
              :class="{ 'checked': estadoVisible === estado.EstadoNombre }"
              @click="estadoVisible = estadoVisible === estado.EstadoNombre ? '' : estado.EstadoNombre; getSubmits(form, currentPage)">
              <span>{{ $t(estado.EstadoNombre) }}</span>
            </div>
            <div
              class="form-check-pill"
              :class="{ 'checked': estadoVisible === 'Pendiente' }"
              @click="estadoVisible = estadoVisible === 'Pendiente' ? '' : 'Pendiente'; getSubmits(form, currentPage)">
              <span>{{ $t('Pendiente') }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Submits -->
      <div v-for="(submit, index) in submits.filter(s => s.Valores[0].IdRespuesta === null)" :key="submit.IdSubmit" class="d-flex flex-column gap-2 w-100 border-0 sombra-sm fondo-secundario rounded-3">
        <!-- Mostrar el nombre del evaluador o 'submit' si no existe -->
        <div class="d-flex flex-row gap-2 w-100 px-3 border border-0 fondo-terciario sombra-sm rounded-3 justify-content-between align-items-center" style="min-height: 60px; cursor: pointer;" @click="submit.showValues = !submit.showValues">
          <div class="d-flex gap-2 align-items-center">
            <div class="d-flex align-items-center justify-content-center p-0">
              <img v-if="submit.IdEvaluadorNavigation?.FotoUrl" :src="submit.IdEvaluadorNavigation?.FotoUrl" alt="Profile Picture" class="img-responsive" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; padding: 2px;" />
              <div v-if="!submit.IdEvaluadorNavigation?.FotoUrl" alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive pb-1" style="width: 40px; height: 40px; border-radius: 50%; background-color: #bbbbbb; object-fit: cover; padding: 2px;" >
                <svg width="20" height="20" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Dribbble-Light-Preview" transform="translate(-140.000000, -2159.000000)" fill="#ffffff"><g id="icons" transform="translate(56.000000, 160.000000)"><path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598" id="profile_round-[#1342]"></path></g></g></svg>
              </div>
            </div>
            <div class="d-flex flex-column align-items-left">
              <span class="d-none d-sm-block">{{ submit.IdEvaluadorNavigation && !form.Anonimo ?
              (submit.IdEvaluadorNavigation?.Apellido + " " + submit.IdEvaluadorNavigation?.Nombre) :
              "Submit " + (index + 1) }}</span>
              <span class="d-block d-sm-none">{{ submit.IdEvaluadorNavigation && !form.Anonimo ?
              (submit.IdEvaluadorNavigation?.Apellido + " " + submit.IdEvaluadorNavigation?.Nombre).substring(0, 12) + '...' :
              "Submit " + (index + 1) }}</span>
              <span class="fs-7 d-flex align-items-center gap-1"> 
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="d-sm-none texto-secundario">
                  {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false, // Para usar el formato de 24 horas
                }).slice(0, 10) }}
                </span>
                <span class="d-none d-sm-inline texto-secundario">
                  {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false, // Para usar el formato de 24 horas
                }) }}
                </span>
              </span>
            </div>
            <router-link :to="'/formularios/completar?idForm='+idForm+'&idSubmit='+submit.IdSubmit" v-if="form.ConEdicionDeCompletado && (form.AQuienEdita === 'Todos' || (form.AQuienEdita === 'Las Propias' && submit.IdEvaluador === user.idPersona))"
              class="btn p-2 d-none d-md-flex flex-row align-items-center justify-content-center tooltip-container border-0">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="tooltip-text">{{ $t('editar') }}</span>
            </router-link>
          </div>

          <div class="d-flex flex-row gap-3 align-items-center">
            <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex-wrap d-sm-flex flex-row p-1 w-100">
              <div v-for="(nivel, nroOrden) in form.AutorizadoresNivel" :key="nroOrden" class="d-inline-flex align-items-center justify-content-center ms-2 gap-2">
                <div class="d-flex gap-1" style="position: relative;">
                  <div class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 text-decoration-none"
                    :class="{ 'select-aprobado': autorizacionNivel(nivel, submit).estado === true,
                              'select-desaprobado': autorizacionNivel(nivel, submit).estado === false,
                              'select-nada': autorizacionNivel(nivel, submit).estado === null}" style="height: 22px;">
                    <svg v-if="autorizacionNivel(nivel, submit).estado === true" width="14" height="14" viewBox="0 1 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M20.6097 5.20743C21.0475 5.54416 21.1294 6.17201 20.7926 6.60976L10.7926 19.6098C10.6172 19.8378 10.352 19.9793 10.0648 19.9979C9.77765 20.0166 9.49637 19.9106 9.29289 19.7072L4.29289 14.7072C3.90237 14.3166 3.90237 13.6835 4.29289 13.2929C4.68342 12.9024 5.31658 12.9024 5.70711 13.2929L9.90178 17.4876L19.2074 5.39034C19.5441 4.95258 20.172 4.87069 20.6097 5.20743Z"/>
                    </svg>
                    <svg v-else-if="autorizacionNivel(nivel, submit).estado === false" class="mx-1 fill-principal" height="10" width="10" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                      viewBox="0 0 47.095 47.095" xml:space="preserve">
                      <path d="M45.363,36.234l-13.158-13.16l12.21-12.21c2.31-2.307,2.31-6.049,0-8.358c-2.308-2.308-6.05-2.307-8.356,0l-12.212,12.21
                        L11.038,1.906c-2.309-2.308-6.051-2.308-8.358,0c-2.307,2.309-2.307,6.049,0,8.358l12.81,12.81L1.732,36.831
                        c-2.309,2.31-2.309,6.05,0,8.359c2.308,2.307,6.049,2.307,8.356,0l13.759-13.758l13.16,13.16c2.308,2.308,6.049,2.308,8.356,0
                        C47.673,42.282,47.672,38.54,45.363,36.234z"/>
                    </svg>
                    <svg v-if="autorizacionNivel(nivel, submit).estado === null" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="fs-7 texto-principal" style="margin-right: 2px;">{{ $t(autorizacionNivel(nivel, submit).nombre) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: submit.showValues ? 'scaleY(1)' : 'scaleY(-1)' }">
              <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
            </svg>
          </div>
        </div>


        <!-- Mostrar los valores solo si showValues es true -->
        <div v-show="submit.showValues">
          <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex flex-row p-1">
            <div v-for="(nivel, nroOrden) in form.AutorizadoresNivel" :key="nroOrden" class="d-flex align-items-center justify-content-center ms-2 gap-2">
              <div class="tooltip-container">
                <div class="rounded-3 d-inline-flex flex-column align-items-center justify-content-center p-1 px-2"
                  :class="{ 'select-aprobado-2': autorizacionNivel(nivel, submit).estado === true,
                            'select-desaprobado-2': autorizacionNivel(nivel, submit).estado === false,
                            'select-nada-2': autorizacionNivel(nivel, submit).estado === null}" style="height: 65px;"
                >
                  <span>{{ $t(autorizacionNivel(nivel, submit).nombre) }}</span>
                  <span v-if="nombreAutorizadorGrupo(nivel, submit).Nombre" class="fs-8 fw-normal">{{ nombreAutorizadorGrupo(nivel, submit).Nombre }}</span>
                  <span v-else class="fs-8 fw-normal">XX xx</span>
                  <span v-if="nombreAutorizadorGrupo(nivel, submit).FechaHora" class="fs-8 fw-normal texto-secundario">{{ nombreAutorizadorGrupo(nivel, submit).FechaHora }}</span>
                </div>
                <span class="tooltip-text-right fondo-secundario border-0">{{ autorizacionNivel(nivel, submit).comentario }}</span>
              </div>
              <div
                v-if="parseInt(nroOrden) < Object.keys(form.AutorizadoresNivel).length-1"
                class="d-inline-block texto-principal mb-1 fs-4"
              >
                →
              </div>
            </div>
          </div>


          
          <!-- Mostrar los valores agrupados -->
          <div v-if="submit.IdEvaluadoNavigation" class="d-flex flex-column gap-2 p-2 px-3">
            <div class="d-flex flex-row justify-content-between w-100">
              <span class="fs-7 m-0"><strong>Evaluado:</strong> &nbsp;{{ (submit.IdEvaluadoNavigation?.Apellido + " " + submit.IdEvaluadoNavigation?.Nombre) }}</span>
            </div>
          </div>
          <div v-for="(valor, indexValue) in submit.Valores" :key="valor.IdSubmit" class="d-flex flex-column gap-1 p-2 px-3">
            <!-- Mostrar los valores agrupados -->
            <div class="d-flex flex-column">
              <div class="d-flex flex-column justify-content-center w-100">
                <span v-if="!valor.ValorObservado.includes('https')" class="fs-6 m-0"> <strong>{{(indexValue+1)+ ". "}}</strong>  {{valor.observacion.NombreObservacion }}: &nbsp;<strong>{{ valor.ValorObservado }}</strong></span>
                <span v-if="valor.ValorObservado.includes('https')" class="fs-6 m-0"><strong>{{ (indexValue+1) }}. Archivo:</strong> &nbsp;<a :href="valor.ValorObservado" target="_blank">{{ valor.Comentario }}</a></span>
                <span class="fs-7 d-flex align-items-center m-0 texto-terciario" style="min-width: 160px;">
                  {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleString('es-AR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hourCycle: 'h23'
                  }) }}
                </span>
              </div>
              <div v-if="valor.Comentario && !valor.ValorObservado.includes('https')" class="d-flex flex-row justify-content-start w-100">
                <span class="fs-6 d-flex align-items-center m-0 ms-3">Comentario: &nbsp;<strong>{{ valor.Comentario }}</strong></span>
              </div>
            </div>

            <div v-if="valor.respuestas && !form.Anonimo" class="d-flex flex-column gap-2">
              <div v-for="(respuesta, indexRespuesta) in valor.respuestas" :key="respuesta.IdSubmit" class="d-flex flex-column w-100">
                <!-- Divider -->
                <div v-if="indexRespuesta!=0" class="col-12 mb-2" style="border-top: 1px solid #ccc; height: 1px"></div>
                <div class="d-flex flex-row gap-2 w-100">
                  <svg class="fill-principal" width="20" height="20" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1);">
                    <path d="M232,56A104.11791,104.11791,0,0,1,128,160H51.31372l34.34351,34.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-48-48c-.05639-.05664-.10424-.11768-.15869-.17578-.12524-.13282-.25122-.26514-.36719-.40625-.09106-.11084-.17114-.22706-.25537-.3418-.07055-.09522-.14477-.188-.21093-.28662-.085-.12647-.15894-.25782-.23584-.38819-.05567-.09423-.11524-.186-.16724-.2832-.06909-.12891-.12817-.26172-.1897-.39355-.04931-.10547-.102-.209-.147-.31641-.05225-.12695-.095-.25586-.14063-.38477-.042-.11816-.08764-.23437-.12426-.355-.03907-.1289-.06787-.25976-.10034-.39013-.03052-.12305-.06519-.24414-.09009-.36914-.03-.15186-.04859-.30469-.06983-.45752-.01465-.106-.03515-.20948-.04565-.3169a8.02276,8.02276,0,0,1,0-1.584c.0105-.10742.031-.21094.04565-.3169.02124-.15283.0398-.30566.06983-.45752.0249-.125.05957-.24609.09009-.36914.03247-.13037.06127-.26123.10034-.39013.03662-.12061.08227-.23682.12426-.355.04566-.12891.08838-.25782.14063-.38477.04492-.10742.09766-.21094.147-.31641.06153-.13183.12061-.26464.1897-.39355.052-.09717.11157-.189.16724-.2832.0769-.13037.15087-.26172.23584-.38819.06616-.09863.14038-.1914.21093-.28662.08423-.11474.16431-.231.25537-.3418.116-.14111.24195-.27343.36719-.40625.05445-.0581.1023-.11914.15869-.17578l48-48a8.00053,8.00053,0,0,1,11.31446,11.31446L51.31372,144H128a88.09957,88.09957,0,0,0,88-88,8,8,0,0,1,16,0Z"/>
                  </svg>
                  <div class="d-flex flex-column justify-content-center w-100">
                    <span class="fs-7 m-0"><strong>{{ $t('respuestaDe') }}&nbsp;{{ respuesta.evaluador }}:</strong>&nbsp;{{ respuesta.valorObservado }}</span>
                    <p class="fs-7 d-flex align-items-center m-0 texto-terciario" style="min-width: 160px;">{{ respuesta.fechaHora }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-if="submits.filter(s => s.Valores[0].IdRespuesta === null) == null || submits.filter(s => s.Valores[0].IdRespuesta === null).length == 0"
        class="text-center fs-5">
        {{ $t('noTenesRespuestas') }}
      </p>
      
      <!-- Controles de Paginación --> 
      <nav aria-label="Page navigation" v-if="totalPages>1">
        <ul class="pagination m-0">
          <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra" :class="{ disabled: currentPage === 1 }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="prevPage()">{{ $t('anterior') }}</a>
          </li>
          <li class="p-2 bg-goethe-accent-claro-3 borde-secundario sombra">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
          </li>
          <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra" :class="{ disabled: currentPage === totalPages }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="nextPage()">{{ $t('siguiente') }}</a>
          </li>
        </ul>
      </nav>
    </div>

    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted, onBeforeUnmount, nextTick  } from 'vue';
  import { API_BASE_URL } from '../../config';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import * as signalR from '@microsoft/signalr';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const form = ref({
      Descripcion: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdCreador: null,
      IdFormulario: null,
      idModificadoPor: null,
      idModificadoPorNavigation: { nombre: '', apellido: ''},
      NombreFormulario: '',
      ConAccesoRestringido: false,
      ConEdicionDeCompletado: false,
      ConVisualizacionRestringida: false,
      AccesoFormularios: [], // Array de objetos para observaciones
      Observacions: [], // Array de objetos para observaciones
    });

    const persona = ref([]);
    const grupos = ref([]);
    const searchQuery = ref(''); // Estado para la búsqueda
    const filteredPersonas = ref([]); // Personas filtradas
    const selectedPersona = ref(null); // Persona seleccionada
    const tipoPermiso = ref('Lector');
    const loading = ref(false);
    const loadingSubmitAcceso = ref(false);
    const loadingOpcionesGrupo = ref(false);
    const errorMessage = ref('');

    let asignaturas = ref([]);
    let submits = ref([]);

    const idForm = localStorage.getItem('idForm');
    let showMenuFilter = ref(false);
    const sortKey = ref('');
    const search = ref('');
    let estadoVisible = ref('');
    const fechaDesde = ref(null);
    const fechaHasta = ref(null);
    let estados = ref([]);
    let connection;
    const gruposDisponibles = ref([]);
    const currentPage = ref(1);
    const totalPages = ref(1);
    let timeoutId = null;
    const showBanner = ref(true);
    const bannerKey = ref('');

    const hasAdminForms = ref(false);

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'VerFormularios'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))||
          user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation.permiso === 'VerTodosForms') ||
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === 'VerTodosForms'))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };
    const toggleMenu = async () => {
      showMenuFilter.value = !showMenuFilter.value;
      
      // Espera al siguiente "tick" de actualización del DOM
      await nextTick();
      
      // Podés poner un console.log aquí para confirmar que se ejecuta después de la actualización
      console.log('El DOM debería estar actualizado ahora. El menú es visible:', showMenuFilter.value);
    };
    const nextPage = () => {
      getSubmits(form.value, currentPage.value + 1)
      currentPage.value += 1
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        getSubmits(form.value, currentPage.value - 1)
        currentPage.value -= 1
      }
    };

    const addRedirectUrl = async () => {
      const url = window.location.href;
      const cleanedUrl = url.split("/#")[1];
      if(cleanedUrl!="/login"){
        localStorage.setItem('redirectAfterLogin', cleanedUrl);
      }
    }

    const closeBanner = () => {
      showBanner.value = false;
      localStorage.setItem(bannerKey.value, 'true');
    };


    const filterSubmits = () => {
      // Limpia el temporizador anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Establece un nuevo temporizador
      timeoutId = setTimeout(() => {
        // Llama a fetchUsers después de 500ms (0.5 segundos) de inactividad
        getSubmits(form.value, currentPage.value);
      }, 1000); // Puedes ajustar este valor a tu gusto (en milisegundos)
    };

    const autorizacionNivel = (nivel, submit) => {
      let autorizacionesDelGrupo = [];

      for (const aut of nivel.Estados) {
        const match = submit.Autorizacion?.filter(a => a.IdAutorizacionEstado === aut.IdAutorizacionEstado)
          .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
        if(match!=null){
          autorizacionesDelGrupo.push(match);
        }
      }

      // Ordenar por FechaHora descendente (más reciente primero)
      autorizacionesDelGrupo.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));

      const match = autorizacionesDelGrupo[0]; // la más reciente de todas las del grupo
      if (match?.AutorizacionEstado?.EstadoNombre !== null && match?.AutorizacionEstado?.EstadoNombre !== undefined) {
        return {nombre: match.AutorizacionEstado.EstadoNombre, comentario: match.Comentario, estado: match.AutorizacionEstado.Autorizado, idEstado: match.AutorizacionEstado.IdAutorizacionEstado};
      }
      return {nombre: 'Pendiente', comentario: '', estado: null, idEstado: null}; // Ninguno respondió aún
    };

    const nombreAutorizadorGrupo = (nivel, submit) => {
      let autorizacionesDelGrupo = [];

      let esDelUsuario = false;
      for (const aut of nivel.Autorizadores) {
        const match = submit.Autorizacion
          .filter(a => a.IdAutorizadores === aut.IdAutorizadores)
          .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
        if(match!=null){
          autorizacionesDelGrupo.push(match);
        }
        if ((aut.IdPersona == user.value?.idPersona && aut.Inhabilitado != true && chequearPermisosAutorizaciones(nivel, submit.IdEvaluador))||(aut.IdPersona == user.value?.idPersona && nivel.SePuedenAutoAutorizar && aut.Inhabilitado != true)) {
          esDelUsuario = true;
        }
      }

      // Ordenar por FechaHora descendente (más reciente primero)
      autorizacionesDelGrupo.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));

      const match2 = autorizacionesDelGrupo[0]; // la más reciente de todas las del grupo


      let autorizacionesDelGrupo2 = [];

      //Nivel Anterior
      let nivelAnterior = form.value.AutorizadoresNivel.find( an => an.NroOrden == (nivel.NroOrden - 1) )
      let debeAutorizarAnterior = false;
      if(nivelAnterior){
        for (const est of nivelAnterior.Estados) {
          const match3 = submit.Autorizacion
            .filter(a => a.IdAutorizacionEstado === est.IdAutorizacionEstado)
            .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
          if(match3!=null){
            autorizacionesDelGrupo2.push(match3);
          }
        }

        // Ordenar por FechaHora descendente (más reciente primero)
        autorizacionesDelGrupo2.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));
        
        autorizacionesDelGrupo2 = autorizacionesDelGrupo2.filter(a => a && a.AutorizacionEstado).filter(a => a.AutorizacionEstado.Autorizado === true);
        let match4 = null;
        match4 = autorizacionesDelGrupo2[0]; // la más reciente de todas las del grupo
        if(match4==null){
          debeAutorizarAnterior = true;
        }
      }
      if(form.value.AutorizarDesordenado){
        debeAutorizarAnterior = false;
      }


      if (match2?.AutorizacionEstado?.EstadoNombre) {
        let fechaHora = new Date(new Date(match2.FechaHora).setHours(new Date(match2.FechaHora).getHours() - 3)).toLocaleString('es-AR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23'
                  })
        return {Nombre: match2.Autorizadores.Persona.Apellido + " " + match2.Autorizadores.Persona.Nombre, FechaHora: fechaHora, EsDelUsuario: esDelUsuario, DebeAutorizarAnterior: debeAutorizarAnterior};
      }
      return {Nombre: null, FechaHora: null, EsDelUsuario: esDelUsuario, DebeAutorizarAnterior: debeAutorizarAnterior};
    };

    const isLink = (value) => {
      const urlPattern = /^(http|https):\/\/[^\s$.?#].[^\s]*$/; // Patrón simple para detectar URLs
      return urlPattern.test(value);
    };


    const fetchForm = async () => {
      try {
        loading.value = true;
        const response = await api.get(`api/Formularios/ByIdBasicoMisRespuestas`, {
            params: {
                id: idForm
            },
        });
        let TempForm = response.data;
        
        if(TempForm.Habilitado == false){
          console.log('Formulario deshabilitado');
          alert('Formulario deshabilitado')
          localStorage.removeItem('redirectAfterLogin');
          await router.push('/formularios');
        }
        
        await getSubmits(TempForm, 1)
        
        console.log(form.value)
        loading.value = false;
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loading.value = false;
      }
    };

    
    const getSubmits = async (TempForm, page) => {
      try {
          loading.value = true;
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          
          let response2 = await api.get(`api/Valores/ByIdFormAndPersona`, {
            params: {
              idForm: idForm,
              valorDeOrden: sortKey.value,
              fechaIni: fechaDesde.value,
              fechaFin: fechaHasta.value,
              page: page,
              estadoFiltro: estadoVisible.value,
              searchValue: search.value
            },
          });

          totalPages.value = response2.data.TotalCount

          // if(response2.data.Submits.length == 0){
          //   router.push(`/formularios/completar?idForm=${idForm}`);
          // }

          submits.value = response2.data.Submits.map(submit => {
            const nivelesCount = TempForm?.AutorizadoresNivel.length || 0;
            return {
              ...submit,
              niveles: Array.from({ length: nivelesCount }, () => ({
                menuVisible: false,
                loadingAutorizacion: false
              }))
            };
          });

          TempForm.Observacions.forEach((observacion) => {
            submits.value.forEach((submit) => {
              observacion.IsChartInProgress = false;
              // Aquí es donde se agregan los valores correspondientes de la respuesta
              const valorEncontrado = submit.Valores.find(o => o.IdObservacion === observacion.IdObservacion);
              if (valorEncontrado) {
                valorEncontrado.observacion = {
                    ...observacion,
                    Valores: []  // Podés vaciarlo sin afectar el original
                  };
                // Clonamos el objeto para no modificar el original
                const observacionValor = JSON.parse(JSON.stringify(valorEncontrado));
                
                observacionValor.Submit = {
                  ...submit,
                  Valores: []  // Podés vaciarlo sin afectar el original
                };
                observacion.Valores.push(observacionValor);
              }
            });
          });

          // Extract unique estados from submits' autorizaciones
          let allEstados = [];
          submits.value.forEach(submit => {
            if (submit.Autorizacion && Array.isArray(submit.Autorizacion)) {
              submit.Autorizacion.forEach(aut => {
                if (aut.AutorizacionEstado) {
                  allEstados.push(aut.AutorizacionEstado);
                }
              });
            }
          });
          estados.value = Array.from(
            new Map(allEstados.map(e => [e.EstadoNombre, e])).values()
          );
          
          //console.log(form.value)
          loading.value = false;
          form.value = TempForm
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loading.value = false;
      }
    };

    const chequearPermisosAutorizaciones = (nivel, IdPersonaSubmit) => {
      // Si el tipo de permiso es "Todos", la autorización es siempre permitida
      if (nivel.TipoPermiso == "Todos") {
        return true;
      }
      else {
        for (const grupo of grupos.value) {
          if (nivel.TipoPermiso === grupo.Nombre && IdPersonaSubmit != null) {
            if (grupo.Opciones[0].PersonasRelacionadas.some(s => s.IdPersona === IdPersonaSubmit)) {
              return true;
            }
          }
        }
      }
      // Si no cumple con las condiciones, denegar autorización
      return false;
    };


    const formatDateTime = (date) => {
      return new Date(date).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit', // Opcional, si quieres incluir los segundos
        hour12: false, // Para usar el formato de 24 horas
      });
    };

    
    onBeforeUnmount(() => {
      if (connection) {
        connection.stop();
      }
    });

    const formatDescription = (text) => {
      if (!text) return '';

      // Placeholder for existing links
      const existingLinks = [];
      let placeholderIndex = 0;

      // Regex to find existing <a> tags, capturing the full tag
      const findAndStoreLinksRegex = /<a[^>]*href=["'][^"']+\.[^"']+\.[^"']+(?:[^"']+)*["'][^>]*>.*?<\/a>/gi;

      // Step 1: Temporarily replace existing <a> tags with placeholders
      // This also handles your specific case where the URL inside href is interpolated
      let processedText = text.replace(findAndStoreLinksRegex, (match) => {
        const placeholder = `__LINK_PLACEHOLDER_${placeholderIndex}__`;
        existingLinks.push({ placeholder, original: match });
        placeholderIndex++;
        return placeholder;
      });

      // Regular expression to find URLs in the remaining plain text
      // This regex is now simpler as it only needs to look for standalone URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;

      // Step 2: Replace standalone URLs in the processed text
      processedText = processedText.replace(urlRegex, (url) => {
        // Ensure the URL isn't part of an existing placeholder's original content (redundant check but safe)
        const isAlreadyLinkedByPlaceholder = existingLinks.some(link => link.original.includes(url));
        if (isAlreadyLinkedByPlaceholder) {
          return url; // Should ideally not happen if placeholders work correctly
        }
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });

      // Step 3: Put the original <a> tags back in their place
      existingLinks.forEach(({ placeholder, original }) => {
        processedText = processedText.replace(placeholder, original);
      });

      return processedText;
    };

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();

      bannerKey.value = 'bannerClosed_' + idForm;
      if (localStorage.getItem(bannerKey.value)) {
        showBanner.value = false;
      }

      connection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}hubs/formulario`)
        .withAutomaticReconnect()
        .build();

      connection
        .start()
        .then(() => {
          console.log("✅ Conectado a SignalR");
        })
        .catch((err) => {
          console.error("❌ Error al conectar a SignalR", err);
        });

      connection.on("FormularioActualizado", (idFormulario) => {
        console.log("🆕 Formulario actualizado:", idFormulario);
        fetchForm();
      });

      connection.onclose(() => {
        console.log("Conexión perdida, intentando reconectar...");
        // opcional: reconectar automáticamente
      });

      await fetchForm();
    });

    return {
      search,
      form,
      persona,
      searchQuery,
      filteredPersonas,
      selectedPersona,
      asignaturas,
      loading,
      loadingSubmitAcceso,
      tipoPermiso,
      errorMessage,
      formatDateTime,
      t,
      isLink,
      submits,
      user,
      hasAdminForms,
      autorizacionNivel,
      nombreAutorizadorGrupo,
      chequearPermisosAutorizaciones,
      sortKey,
      filterSubmits,
      fechaDesde,
      fechaHasta,
      estados,
      estadoVisible,
      idForm,
      gruposDisponibles,
      loadingOpcionesGrupo,
      addRedirectUrl,
      currentPage,
      totalPages,
      nextPage,
      prevPage,
      getSubmits,
      toggleMenu,
      formatDescription,
      showMenuFilter,
      showBanner,
      closeBanner
    };
  },
};
</script>

<style scoped>

.list-group {
  max-height: 200px; /* Ajusta según lo necesario */
  overflow-y: auto; /* Añade desplazamiento si es necesario */
}

.list-group-item {
  background-color: white; /* Color de fondo de los items */
  text-align: left;
}

.list-group-item:hover {
  background-color: #f8f9fa; /* Color al pasar el mouse */
}
.chart-canvas {
  width: 100% !important; /* Asegúrate de que ocupe todo el ancho */
  max-height: 400px; /* Establece una altura fija */
}

.share-menu {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid var(--fondo-principal);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  text-align: center;
  max-width: 600px;
  width: 90%;
}
.close-icon {
    /* Posiciona el ícono de cierre en la esquina superior derecha */
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}

.custom-context-menu {
  /* Estilo para el menú */
  min-width: 120px;
  border: 1px solid var(--fondo-secundario);
  border-radius: 4px;
  position: absolute;
  z-index: 10;
}

.overlay-2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);  /* Fondo semitransparente */
  z-index: 5;  /* Coloca la capa por debajo del menú */
}

.floating-banner {
  position: relative;
  margin-top: 10px;
}

.floating-banner::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--fondo-terciario); /* Bootstrap alert-info background color */
}

</style>
